import { CircularProgress } from "@stacklet/ui";

/** Full-viewport spinner for the sign-in gate while it waits on Amplify. */
export function CenteredLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-overlay-medium">
      <CircularProgress size="xl" />
    </div>
  );
}
